import { render, staticRenderFns } from "./AddTtsResourceFields.vue?vue&type=template&id=2e8d3632&scoped=true"
import script from "./AddTtsResourceFields.vue?vue&type=script&lang=js"
export * from "./AddTtsResourceFields.vue?vue&type=script&lang=js"
import style0 from "./AddTtsResourceFields.vue?vue&type=style&index=0&id=2e8d3632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8d3632",
  null
  
)

export default component.exports